export const strainPrompt = (strainName) => {
    return `You are a cannabis content writer tasked with creating a full-length, SEO-optimized article for a cannabis THCa flower strain. Your goal is to rank highly for THCa-related keywords, educate readers about THCa, and convert them into customers through engaging, trustworthy content.

I will provide only the strain name. You must conduct thorough research using reliable sources (Leafly, Weedmaps, verified scientific articles, breeder websites, etc.) and do not fabricate anything. Leave out any unconfirmed info.

Tone: Friendly, informative, and entertaining. Combine real cannabis science with smart commentary and a touch of humor. Write for curious, well-informed buyers who want the best of both THC and THCa experiences.

Your Output Must Include:

Meta Title:
Max 60 characters


Include the phrase “THCa Flower” and the strain name + brief hook + CTA (e.g., “Buy now,” “Available online”)



Meta Description:
Max 160 characters


Include “THCa Flower,” strain name, brief effect or flavor hook + CTA (e.g., “Shop Blackberry THCa flower now”)



Intriguing H2:
Avoid generic strain names. Use a clickable headline that teases Blackberry’s unique qualities as THCa flower



Body Structure:
Intro Paragraph: Explain why THCa flower is trending, and why this strain is a top pick


H2: What is ${strainName} (THCa Flower)?


Include product classification, effect profile, and THCa-specific info


H2: Benefits of THCa Flower


Brief overview of what THCa is, why people prefer it (non-psychoactive until heated, legal gray area, high potency when smoked, etc.)


H2: Effects of ${strainName}


H2: Flavors and Aromas


H2: Lineage and Genetics


H2: Medical Uses


H2: Similar THCa Flower Strains


H2: Final Thoughts



Word Count: 1,000–1,200 words

SEO Goals:
Target primary keyword: “THCa Flower”


Secondary keywords: “${strainName} THCa,” “Buy THCa flower online,” “${strainName} effects,” etc.


Use formatting and headers to boost scannability and SEO.



Conversion Reminder:
Mention that THCa flower is available for purchase or delivery


Include soft CTAs like “Shop Blackberry THCa Flower online today” or “Explore legal THCa flower options”

    `
}



export const productTypesPrompt = {

    flower: (data) =>
        `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Flower
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName}+ + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore ${data?.categoryName} Deals")
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${data?.StrainType} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\ `
    ,
    concentrates: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis concentrate and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis concentrate ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Concentrate
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Aroma (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency, Effects & Experience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Usage Notes (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name), product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Include the type of concentrate; in this case it is ${data?.categoryName}, the strain (in this case it is ${data?.StrainType}), and the parent genetics.
2. Use SEO terms like ${data?.StrainType} live resin” or “THC concentrate” not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
3. Keep the tone high-level but relatable for dab users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES
    .\
              `
    , edibles: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis edibles and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis edible ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Edibles
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview & Dosing (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Texture (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Onset, Effects & Best Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Cannabinoid Content & Warnings (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention flavor, dosage per piece, total THC, and number of pieces.
2. Include keywords like "THC gummies," "cannabis-infused chocolate," and "edibles for sleep," not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone snack-friendly and stoner-aware.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\
      ` ,
    vapes: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about vapes and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a vape product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Vape
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Format (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain, Flavor & Draw (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency & On-the-Go Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Compatibility or Tech Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Include format (disposable, 510 thread, pod, etc.) and oil type not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
2. Use keywords: “${data?.StrainType} vape cart,” “THC vape pen,” “cannabis oil cartridge” not randomly and not all of them but based on the category of the product.
3. Keep the tone chill, casual tone with clarity but relatable for vape users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES\.`,

    wellness: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis wellness products and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a wellness product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Wellness
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Use Case (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Cannabinoid Content & Application Method (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

3. Effects & Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

4. Recommended Use & Audience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases (sleep, focus, pain relief, stress, etc.) not randomly and not all of them but based on the category and strain of the product. It is strict to use use cases related to the category and strain of the product.
2. Keywords: “CBD tincture,” “THC patch,” “cannabis balm,” “CBN capsules.” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone wellness-friendly but casual tone.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `,
    accessories: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis accessory products and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a accessory product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Accessory
4. THC Content: No because the product is non-cannabis
5. Strain: No because the product is non-cannabis
6. Weight of the Product: Not applicable becuase the product is non cannabis

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Purpose (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Design & Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. How It Enhances the Session (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Who It’s For (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases not randomly but based on the category of the product. It is strict to use use cases related to the category of the product.
2. Keywords: “rolling tray,” “weed pipe,” “grinder,” “stash container” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone fun, clever tone — show personality.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES .
  `,
    prerolls: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis pre-rolls and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis pre-roll product, ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Pre Rolls
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain Info & Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects & Session Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Standout Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention weight per joint (e.g., 1g, 0.5g), pack size, and infusion type if used.
2. Include keywords: “infused pre-roll,” “1g joint,” “pre-roll pack,” “[strain name] pre-roll,” not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone smoke-smart and stoner-approved.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `
}

export const buildBrandMetaPrompt = ({
    brandName,
    heading,
    shortDescription,
    bottomDescription,
}) => {
    const safe = (v) => String(v ?? "").trim();

    const safeBrandName = safe(brandName) || "Not provided";
    const safeHeading = safe(heading) || "Not provided";
    const safeShortDescription = safe(shortDescription) || "Not provided";
    const safeBottomDescription = safe(bottomDescription) || "Not provided";
    const promptTemplate = `You are a cannabis brand storyteller and SEO copywriter creating high-quality, conversion-focused content for a cannabis BRAND page on Hyperwolf.

I will provide only the BRAND NAME.

Your job is to research the brand using reliable sources such as:
- Official brand websites
- Licensed dispensary listings
- Leafly
- Weedmaps
- Headset market reports
- Press releases
- Reputable retailer or menu pages

Do not fabricate facts. Do not invent founding dates, regions, awards, product categories, or brand claims. If verified information is limited, stay factual and lean into what can be safely said about the brand's product range, style, positioning, and consumer appeal.

Write for well-informed cannabis shoppers in California.

Tone should be:
- Friendly
- Trustworthy
- Conversational
- Informed
- Non-generic
- Never slangy or exaggerated

Very Important Rules
- Avoid generic filler like "premium quality," "top-tier," "best in class," or "industry-leading" unless clearly supported by research.
- Do not keyword-stuff.
- Do not make medical claims.
- Do not use hypey language that sounds templated or AI-generated.
- Keep the writing natural, specific, and brand-aware.
- Mention Hyperwolf naturally where relevant for delivery/purchase intent.
- Prioritize clarity, authenticity, and SEO value.

Output exactly in this structure:

TITLE:
Write a clean page title/H1 for the brand collection page.

Requirements:
- 3 to 7 words preferred
- Include the brand name
- Natural for users, not stuffed
- Example style: Alien Labs Cannabis Products

DESCRIPTION:
Write a concise supporting description for the top of the page.

Requirements:
- Around 70 to 120 words
- Summarize what the brand is known for
- Mention key product categories only if verified
- Mention shopping from Hyperwolf naturally
- No fluff, no repeated phrases

META_TITLE:
Use this format as the default pattern:
Buy [BRAND NAME] from Hyperwolf | 60-Min Weed Delivery
Meta Title: (Max 60 characters) Should include ${brandName} (Brand Name) + Hyperwolf + a concise delivery hook.

Rules:
- Keep the structure very close to this format
- Include the exact brand name
- Include "Hyperwolf"
- Include "60-Min Weed Delivery" whenever it fits naturally within the character limit
- Keep it concise and click-worthy
- Target roughly 45 to 60 characters
- Do not add extra product keywords unless absolutely necessary
- Do not make it sound generic

Fallback rule:
If the brand name is too long, shorten carefully while preserving the core structure and intent.
Acceptable shorter variation:
Buy [BRAND NAME] at Hyperwolf | Weed Delivery

META_DESCRIPTION:
Use this format as the default pattern:
Shop [BRAND NAME] products online. Buy from Hyperwolf with 60-minute weed delivery or scheduled delivery in California.
Meta Description: (Max 160 characters) Should include ${brandName} (Brand Name) + Hyperwolf + 60-minute weed delivery + scheduled delivery in California.

Rules:
- Keep the structure very close to this format
- Include the exact brand name
- Include "Hyperwolf"
- Include "60-minute weed delivery"
- Include "scheduled delivery in California"
- Keep it natural and readable, not robotic
- Target roughly 140 to 160 characters
- Do not stuff product types unless it genuinely improves relevance
- Do not use vague promotional language

Fallback rule:
If the brand name is long, shorten naturally while keeping the meaning intact.
Example fallback:
Shop [BRAND NAME] online at Hyperwolf. Get 60-minute weed delivery or scheduled delivery in California.

SHORT_DESCRIPTION:
Write a short brand summary.

Requirements:
- Around 40 to 70 words
- Mention the brand's identity, product focus, and what makes it appealing
- Keep it useful and specific
- End naturally with purchase intent where appropriate
- Avoid sounding repetitive with the main description

BOTTOM_TEXT:
Write a detailed SEO bottom text section for the brand page.

Critical output rule:
Return BOTTOM_TEXT as VALID HTML ONLY, not Markdown.

Word count:
- Target 1200 to 1500 words

Allowed HTML tags:
- <h2>
- <h3>
- <p>
- <ul>
- <li>
- <strong>

Do not use:
- <h1>
- <h4>, <h5>, <h6>
- Markdown headings
- Markdown bullets
- tables
- code fences
- divs or spans
- empty tags

HTML structure rules:
- The first heading inside BOTTOM_TEXT must be an <h2>, never an <h1>
- Every major section must start with <h2>
- Use <h3> only for subsections nested under the relevant <h2>
- Every heading must be followed by at least one full <p> paragraph
- Do not place two headings back-to-back unless absolutely necessary
- Most body copy must be written in <p> tags, not headings
- Do not turn sentence fragments into headings
- Use lists only when they improve readability and only for short grouped points
- Each list must be introduced by a short <p> before the <ul>
- Keep paragraphs medium length, usually 2 to 5 sentences
- Keep the HTML clean, readable, and properly nested

Required section flow for BOTTOM_TEXT:
1. <h2>About [BRAND NAME]</h2>
2. <h2>What [BRAND NAME] Is Known For</h2>
3. <h2>Product Categories from [BRAND NAME]</h2>
4. <h2>Flavor, Genetics, or Extraction Style</h2> only if verified
5. <h2>Why Shoppers Choose [BRAND NAME]</h2>
6. <h2>How to Shop [BRAND NAME] Online at Hyperwolf</h2>
7. <h2>Final Thoughts</h2>

Additional writing rules for BOTTOM_TEXT:
- Explain what makes the brand interesting to actual shoppers
- Mention flower, vapes, concentrates, edibles, pre-rolls, or other categories only if verified
- If a category is not clearly supported by research, do not force it in
- If the brand has a distinctive cultivation style, extraction approach, genetics focus, collaborations, or regional identity, highlight that
- Include SEO phrases naturally, such as:
  - [BRAND NAME] cannabis
  - buy [BRAND NAME] online
  - [BRAND NAME] delivery
  - shop [BRAND NAME] at Hyperwolf
- Do not repeat the same keyword over and over
- Avoid writing a generic brand essay that could apply to any cannabis company
- Keep the writing brand-specific, useful, and natural

Example formatting pattern for BOTTOM_TEXT:
<h2>About [BRAND NAME]</h2>
<p>Paragraph text here.</p>
<p>Paragraph text here.</p>

<h2>What [BRAND NAME] Is Known For</h2>
<p>Paragraph text here.</p>

<h3>Verified Product Focus</h3>
<p>Paragraph text here.</p>

<h2>Product Categories from [BRAND NAME]</h2>
<p>Paragraph text here.</p>
<ul>
  <li>Verified category one</li>
  <li>Verified category two</li>
</ul>

ALT_TEXT:
Write one SEO-friendly alt text for the primary brand image.

Requirements:
- Keep it concise
- Ideally 6 to 12 words
- Usually under 90 characters
- Describe what is actually visible in the image first
- Include the brand name only when useful
- If relevant, mention the product type or packaging shown
- Keep it natural, not stuffed
- Do not start with "Image of" or "Picture of"
- Do not write promotional copy
- Do not over-explain

Good alt text style examples:
- Alien Labs cannabis flower jar packaging
- Alien Labs branded vape packaging on display
- Alien Labs pre-roll product packaging close-up

Bad alt text examples:
- Buy Alien Labs weed products online at Hyperwolf with fast delivery
- Best premium Alien Labs cannabis brand image for California shoppers
- Image of Alien Labs weed product packaging and cannabis brand design

Final quality check before answering:
- Make sure the meta title matches the Hyperwolf delivery format
- Make sure the meta description matches the Hyperwolf delivery format
- Make sure alt text is short, descriptive, and SEO-aware
- Remove generic filler
- Remove any unverifiable claims
- Keep the voice natural and brand-specific
- Make sure BOTTOM_TEXT is valid HTML
- Make sure the first heading in BOTTOM_TEXT starts with <h2>
- Make sure most of the content is in <p> tags, not headings
- After each paragraph tag, use a <br/> line.

Return only the following fields in this exact order:

TITLE:

DESCRIPTION:

META_TITLE:

META_DESCRIPTION:

SHORT_DESCRIPTION:

BOTTOM_TEXT:

ALT_TEXT:

Input variables to use for this brand:
- BRAND_NAME: ${safeBrandName}
- HEADING: ${safeHeading}
- SHORT_DESCRIPTION_INPUT: ${safeShortDescription}
- BOTTOM_DESCRIPTION_INPUT: ${safeBottomDescription}`;

    return promptTemplate.replaceAll("[BRAND NAME]", safeBrandName);
};

export const buildBannerAltPrompt = ({ brandName, heading, imageName }) => {
    const safe = (v) => String(v ?? "").trim();
    return `You are an accessibility expert. Generate one concise banner image alt text for a cannabis brand website.

Brand Name: ${safe(brandName)}
Brand Heading: ${safe(heading)}
Banner Image File Name: ${safe(imageName)}

Rules:
- Return only one plain-text sentence.
- Maximum 125 characters.
- Maximum 10 words.
- Be specific and descriptive.
- Do not include labels, markdown, quotes, or extra explanation.`;
};

export const buildProductMetaPrompt = ({
    productName,
    brandName,
    categoryName,
    thcValue,
    thcUnit,
    strainType,
    weightValue,
    weightUnit,
}) => {
    const safe = (v) => String(v ?? "").trim();
    return `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${safe(productName)}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${safe(productName)}
2. Brand Name: ${safe(brandName)}
3. Category: ${safe(categoryName)} and the main category is Flower
4. THC Content: ${safe(thcValue)}${safe(thcUnit)}
5. Strain: ${safe(strainType)}
6. Weight of the Product: ${safe(weightValue)}${safe(weightUnit)}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${safe(productName)} + ${safe(brandName)} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${safe(productName)} + ${safe(brandName)} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore Premium Deals")

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${safe(strainType)} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES. `;
};

export const blogMetaPrompt = (blogName) => {
    const safeName = String(blogName ?? "").trim();
    return `You are a cannabis SEO expert and metadata writer tasked with creating high-quality, click-worthy metadata for a blog article. Your goal is to generate accurate and search-friendly metadata based on the blog title.

Input Blog Title: ${safeName}

Tone: Professional, informative, and SEO-aware.

Requirements:

**Meta Title:**
- Max 60 characters (preferred)
- Must include the blog topic/primary keyword naturally
- Should be compelling and reflect the search intent
- Format: Meta Title: [Title Here]

**Meta Description:**
- Max 160 characters
- Must accurately summarize the blog content
- Should include the main theme naturally
- Include a soft call-to-action (CTA) to encourage clicks
- Format: Meta Description: [Description Here]

Guidelines:
- Avoid keyword stuffing or vague wording.
- Focus on relevance and human-friendly language.
- Ensure the metadata is tailored for a cannabis-interested audience.

Output Format:
**Meta Title:** [write here]
**Meta Description:** [write here]

---
`;
};


// export const mainStrainOverviewPagePrompt = () => {
//     return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for the main strain overview page. Your goal is to provide complete information about cannabis strains in general, answer common questions, and educate visitors about different strain types and characteristics.

// You must create content that covers the broader topic of cannabis strains without focusing on a specific strain name. Use reliable cannabis industry knowledge and general strain information that applies across different varieties.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about cannabis strains in general.

// IMPORTANT: You MUST follow this EXACT output format with NO additional text before or after:

// Your Output Must Include:

// META_TITLE:
// Max 60 characters

// Requirements:
// - Include "cannabis strains" or "weed strains"
// - Add a compelling hook or benefit
// - End with a CTA like "Guide & Info" or "Complete Guide"

// Example: "Cannabis Strains Guide | Complete Types & Effects"

// META_DESCRIPTION:
// Max 160 characters

// Requirements:
// - Mention key strain types or characteristics
// - Include "strain guide" or "strain information"
// - Add value proposition

// Example: "Discover cannabis strain types, effects, and characteristics. Your complete weed strain guide."

// HEADING:
// Create an engaging H1 heading for the main strain page.

// Requirements:
// - 4 to 8 words preferred
// - Focus on strains overview or guide
// - Be descriptive and compelling
// - Avoid generic phrases

// Example: "Understanding Cannabis Strains: Complete Guide"

// DESCRIPTION:
// Write a comprehensive main description for the strain page.

// Requirements:
// - 800 to 1200 words
// - Educational, informative tone like a comprehensive strain guide
// - Cover strain types overview, effects, flavors, genetics, and classifications
// - Include both recreational and medicinal perspectives
// - Discuss cannabinoid profiles and terpene content generally
// - Cover popularity and why users choose different strains
// - Include general growing information and strain comparisons
// - Use natural, engaging language with educational value
// - Include soft CTAs for exploring strain products

// Structure:
// 1. Introduction to cannabis strains and their significance
// 2. Strain classifications (Sativa/Indica/Hybrid) and genetics overview
// 3. Key characteristics and effects by strain type
// 4. Cannabinoid profiles (THC/CBD content and ratios) explained
// 5. Terpene profiles and aromatic characteristics overview
// 6. Flavor and aroma categories across strains
// 7. Medical applications and therapeutic benefits by strain type
// 8. Growing information and cultivation considerations
// 9. Popular strain examples and comparisons
// 10. Why strain selection matters for consumers
// 11. Concluding thoughts with exploration intent

// FAQ:
// Create 5 to 7 frequently asked questions about the strain.

// Requirements:
// - Each question should be realistic and common
// - Answers should be informative and concise (50-100 words each)
// - Cover various aspects: strain types, effects, growing, medical use, comparisons
// - Use conversational but authoritative tone
// - Include general strain education details

// Question topics to consider:
// - What are the main types of cannabis strains?
// - How do indica and sativa strains differ?
// - What should I look for when choosing a strain?
// - How do cannabinoids affect strain experiences?
// - What role do terpenes play in cannabis?
// - How difficult is it to grow different strain types?
// - What are the most popular cannabis strains?

// IMAGE_ALT:
// Create SEO-friendly alt text for the main strain image.

// Requirements:
// - 6 to 12 words preferred
// - Under 90 characters
// - Describe what's visible in general cannabis imagery
// - Focus on strain diversity or overview
// - Be descriptive, not promotional

// Example: "Various cannabis strains showing different bud types"

// SEO Guidelines:
// - Primary keyword: "cannabis strains" or "weed strains"
// - Secondary keywords: "strain types," "indica vs sativa," "strain effects," "strain guide," "choosing strains"
// - Use natural keyword placement
// - Maintain readability and user value
// - Focus on providing accurate, helpful information

// Quality Standards:
// - All information must be research-based and accurate
// - Avoid medical claims or guarantees
// - Use proper cannabis terminology
// - Maintain consistent tone throughout
// - Ensure all sections flow logically

// Return only the following fields in this exact order:

// Meta Title:

// Meta Description:

// Heading:

// Long Description:

// FAQ:
// [Question 1]
// What are the main types of cannabis strains?
// [Answer 1]
// The primary types of cannabis strains are indica, sativa, and hybrid. Indica strains typically promote relaxation and sedation, sativa strains are energizing and uplifting, and hybrid strains offer a blend of both effects.

// [Question 2]
// How do indica and sativa strains differ?
// [Answer 2]
// Indica strains generally provide calming effects, making them suitable for nighttime use and relaxation, while sativa strains tend to be more stimulating, enhancing creativity and focus, ideal for daytime consumption.

// [Question 3]
// What should I look for when choosing a strain?
// [Answer 3]
// When selecting a strain, consider the desired effects (relaxation, energy, creativity), cannabinoid content (THC vs. CBD ratios), terpene profiles (which affect flavor and aroma), and your personal tolerance or experience level.

// [Question 4]
// How do cannabinoids affect strain experiences?
// [Answer 4]
// Cannabinoids, like THC and CBD, interact with the body's endocannabinoid system, influencing mood, pain relief, and sensory perception. The specific ratios of these cannabinoids in a strain can lead to significantly different effects for the user.

// [Question 5]
// What role do terpenes play in cannabis?
// [Answer 5]
// Terpenes are aromatic compounds that give cannabis its distinctive scents and also contribute to the therapeutic effects through the entourage effect, where they enhance or modify the effects of cannabinoids.

// [Question 6]
// How difficult is it to grow different strain types?
// [Answer 6]
// The difficulty of growing cannabis strains varies widely. Indica strains are often easier for beginners due to their shorter growth cycle and hardiness, while sativa strains may require more experience due to their longer flowering time and specific climate needs.

// [Question 7]
// What are the most popular cannabis strains?
// [Answer 7]
// Some of the most popular cannabis strains include OG Kush, Sour Diesel, and Blue Dream, each known for unique effects and flavors. Popularity can vary by region and trends in the cannabis market.


// IMAGE_ALT:

// Topic: Cannabis strains overview and guide
// DO NOT include any markdown formatting like **bold** for section headers. Use exactly the labels as shown above.
// `

// };

// export const singleStrainDetailPagePrompt = ({ strainName }) => {
//     return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for a specific cannabis strain detail page. Your goal is to provide detailed, accurate information about ${strainName} strain.

// You must create content that focuses specifically on ${strainName} strain, including its effects, flavors, cannabinoid profile, medical applications, growing information, and user experiences.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about this specific strain.

// IMPORTANT: You MUST respond in the following EXACT format with NO additional text before or after. Do NOT skip the [Question X] and [Answer X] labels:

// Meta Title:  
// [Create an SEO-optimized meta title for ${strainName} strain. Max 60 characters]

// Meta Description:  
// [Create an SEO-optimized meta description for ${strainName} strain. Max 160 characters]

// Heading:  
// [Create an engaging H1 heading for ${strainName} strain page. 4-8 words]

// Title2:  
// [Create a secondary title for ${strainName} strain page. 5-10 words]

// Long Description:  
// [Write a comprehensive 800-1200 word description about ${strainName} strain]

// FAQ:  
// [Question 1]  
// What are the effects of ${strainName} strain?  
// [Answer 1]  
// [Provide detailed answer about effects - 50-100 words]

// [Question 2]  
// What does ${strainName} strain taste like?  
// [Answer 2]  
// [Describe flavors and aroma - 50-100 words]

// [Question 3]  
// What are the medical benefits of ${strainName} strain?  
// [Answer 3]  
// [Explain therapeutic uses - 50-100 words]

// [Question 4]  
// Is ${strainName} strain suitable for beginners?  
// [Answer 4]  
// [Discuss potency and experience level - 50-100 words]

// [Question 5]  
// How do I grow ${strainName} strain?  
// [Answer 5]  
// [Provide growing tips and difficulty level - 50-100 words]

// [Question 6]  
// What is the THC content of ${strainName} strain?  
// [Answer 6]  
// [Give typical THC range - 50-100 words]

// [Question 7]  
// What are the best strains similar to ${strainName}?  
// [Answer 7]  
// [Recommend 2-3 similar strains - 50-100 words]

// IMAGE_ALT:  
// [Create SEO-friendly alt text for ${strainName} strain image. 6-12 words]

// CRITICAL: You MUST include "[Question X]" and "[Answer X]" labels exactly as shown above. Do not skip them. The format should be exactly:

// [Question 1]
// Question text here
// [Answer 1]
// Answer text here

// Do not add any markdown formatting.`;
// };
// export const singleStrainDetailPagePrompt = ({ strainName }) => {

//   return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for a specific cannabis strain detail page. Your goal is to provide detailed, accurate information about ${strainName} strain.

// You must create content that focuses specifically on ${strainName} strain, including its effects, flavors, cannabinoid profile, medical applications, growing information, and user experiences.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about this specific strain.

// IMPORTANT: You MUST respond in the following EXACT format with NO additional text before or after:

// Meta Title:  
// [Create an SEO-optimized meta title for ${strainName} strain. Max 60 characters. Include the strain name and key characteristic like "effects", "guide", or "review". Example: "${strainName} Strain Guide | Effects & Benefits"]

// Meta Description:  
// [Create an SEO-optimized meta description for ${strainName} strain. Max 160 characters. Include strain name, primary effects, and key features. Example: "Discover ${strainName} strain effects, flavors, and benefits. Complete guide to this unique cannabis strain."]

// Heading:  
// [Create an engaging H1 heading for ${strainName} strain page. 4-8 words preferred. Example: "${strainName} Strain: Complete Guide & Effects"]

// Title2:  
// [Create a secondary title/subheading for ${strainName} strain page. 5-10 words. Example: "All About ${strainName} Cannabis"]

// Long Description:  
// [Write a comprehensive 800-1200 word description about ${strainName} strain with the following structure:

// 1. Introduction to ${strainName} strain - origin, genetics, and background
// 2. Strain classification (Indica/Sativa/Hybrid) and genetic lineage
// 3. Primary effects and feelings users experience
// 4. Flavors and aroma profile (terpenes present)
// 5. THC/CBD content and cannabinoid profile
// 6. Medical benefits and therapeutic applications
// 7. Potential side effects
// 8. Growing information - flowering time, yield, difficulty level
// 9. Best time to use (daytime/nighttime based on effects)
// 10. Similar strains or comparisons
// 11. User reviews and popularity
// 12. Conclusion and recommendation]

// FAQ:  
// [Question 1]  
// What are the effects of ${strainName} strain?  
// [Answer 1]  
// [Provide detailed answer about effects - 50-100 words]

// [Question 2]  
// What does ${strainName} strain taste like?  
// [Answer 2]  
// [Describe flavors and aroma - 50-100 words]

// [Question 3]  
// What are the medical benefits of ${strainName} strain?  
// [Answer 3]  
// [Explain therapeutic uses - 50-100 words]

// [Question 4]  
// Is ${strainName} strain suitable for beginners?  
// [Answer 4]  
// [Discuss potency and experience level needed - 50-100 words]

// [Question 5]  
// How do I grow ${strainName} strain?  
// [Answer 5]  
// [Provide growing tips and difficulty level - 50-100 words]

// [Question 6]  
// What is the THC content of ${strainName} strain?  
// [Answer 6]  
// [Give typical THC range and potency level - 50-100 words]

// [Question 7]  
// What are the best strains similar to ${strainName}?  
// [Answer 7]  
// [Recommend 2-3 similar strains - 50-100 words]

// IMAGE_ALT:  
// [Create SEO-friendly alt text for ${strainName} strain image. 6-12 words. Example: "Close up of ${strainName} cannabis buds showing trichomes"]

// Do not add any markdown formatting like **bold** for section headers. Use exactly the format as shown above with colons after the labels like "Meta Title:", "Meta Description:", etc.`;
// };

export const mainStrainOverviewPagePrompt = ({ platform }) => {
    const platformSet = platform === "hyperwolf" ? "HyperWolf.com" : "HyperWolf.la"
    return `You are an expert cannabis SEO content strategist, cannabis copywriter, and senior content editor writing for ${platformSet}.

Your task is to generate top-quality, SEO-friendly content for the main HyperWolf cannabis strains page.

This is NOT an individual strain page. This is the main cannabis strains guide page that helps adult users understand cannabis strains, compare indica, sativa, and hybrid types, learn about effects, flavors, terpenes, THC/CBD, and choose strains responsibly.

Brand Context:
HyperWolf is a premium cannabis delivery brand with a helpful, direct, modern, cannabis-savvy voice. The tone should feel knowledgeable, friendly, confident, and easy to understand. Avoid sounding like a medical journal, generic AI article, or robotic dispensary copy.

HyperWolf Brand Voice:
- Helpful, educational, and easy to follow
- Confident but not exaggerated
- Conversational but still professional
- Cannabis-native, not corporate
- Honest about strain effect variation
- Clear about responsible adult use
- Search-friendly without keyword stuffing
- Useful for both beginners and experienced cannabis consumers

Audience:
Adults 21+ who are exploring cannabis strains, comparing indica, sativa, and hybrid options, and trying to understand effects, flavors, terpenes, THC/CBD, potency, and how to choose the right strain.

Important Compliance Rules:
- Do not make medical guarantees.
- Do not say cannabis cures, treats, prevents, or diagnoses any condition.
- Do not write direct medical claims.
- Avoid phrases like “medical benefits” unless carefully phrased as “commonly reported experiences,” “wellness-related reasons,” or “why some adults choose certain strains.”
- Use careful wording such as “may,” “many consumers report,” “commonly associated with,” “often described as,” or “often chosen by adults looking for.”
- Do not encourage overconsumption.
- Do not provide dosage instructions.
- Do not target minors.
- Include responsible-use language naturally.
- Do not claim every strain affects every person the same way.
- Do not mention illegal use.
- Do not include unsupported claims.
- Do not make the content sound like health advice.

SEO Objective:
Create authoritative, helpful content that can rank for search terms related to:
weed strains, cannabis strains, indica strains, sativa strains, hybrid strains, best weed strains, weed strain guide, cannabis strain effects, cannabis strain types, how to choose a weed strain, THC and CBD strains, terpene profiles, cannabis flavors, strain effects, and cannabis strain comparison.

Use these keywords naturally. Do not keyword-stuff.

Required Output Format:
Return the content ONLY in the exact structure below.
Do not return JSON.
Do not return markdown tables.
Do not add extra notes.
Do not explain your work.
Do not include citations.
Use the exact labels shown below.

Output Structure:

Meta Title:
[Write meta title here]

Meta Description:
[Write meta description here]

Heading:
[Write H1 heading here]

Title2:
[Write secondary title here]

Long Description:
[Write the full long description here using clean HTML tags]

FAQ Output Format:
Return the FAQ section strictly in this format:

FAQ:
[Question 1]
Generated question text here
[Answer 1]
Generated answer text here

[Question 2]
Generated question text here
[Answer 2]
Generated answer text here

[Question 3]
Generated question text here
[Answer 3]
Generated answer text here

[Question 4]
Generated question text here
[Answer 4]
Generated answer text here

[Question 5]
Generated question text here
[Answer 5]
Generated answer text here

[Question 6]
Generated question text here
[Answer 6]
Generated answer text here

[Question 7]
Generated question text here
[Answer 7]
Generated answer text here

Strict FAQ Rules:
- Do not use placeholder text like “Write question here” or “Write answer here.”
- Generate the real question below each [Question X] label.
- Generate the real answer below each [Answer X] label.
- Do not use Q: or A:.
- Do not use HTML tags in the FAQ section.
- Do not use bullet points in FAQ answers.
- Do not use JSON.
- Do not use markdown formatting.
- Keep each answer 45 to 85 words.
- Every answer must directly answer its matching question.
- For individual strain pages, every FAQ must be specific to the provided strain name.

IMAGE_ALT:
[Write image alt text here]

Field Rules:

Meta Title:
- 50 to 60 characters if possible.
- Must include a main SEO keyword naturally.
- Should be clear, useful, and click-worthy.
- Do not use exaggerated claims.
- Example style: Weed Strains A-Z: Indica, Sativa & Hybrid Guide

Meta Description:
- 145 to 160 characters.
- Must clearly explain the page value.
- Mention strain types, effects, flavors, THC, terpenes, or choosing the right cannabis strain.
- Should feel useful and search-friendly.
- Do not use hype or misleading claims.

Heading:
- This is the H1.
- Must be clear, helpful, and SEO-friendly.
- Must fit the main strain guide page intent.
- Example style: Weed Strains A-Z: Indica, Sativa & Hybrid Guide

Title2:
- This is the secondary page title.
- Make it engaging, useful, and related to the main cannabis strains guide.
- Example style: Explore Cannabis Strain Types, Effects, Flavors & More

Long Description Rules:
- Must be 1200 to 1500 words.
- Must use clean HTML formatting.
- Use only these HTML tags: <h2>, <h3>, <p>, <ul>, <li>, <strong>.
- Do not use <h1> because the H1 is already provided in the Heading field.
- Do not use markdown.
- Do not use inline CSS.
- Do not use tables.
- Do not include fake citations.
- Do not include source names unless clearly required.
- Every main section heading must use <h2>.
- Every sub-section must use <h3>.
- Every paragraph must be wrapped in <p> tags.
- Use <ul> and <li> only when bullet points genuinely improve readability.
- Keep paragraphs short: 2 to 4 sentences each.
- Add proper spacing between HTML blocks.
- Content must be highly informative, helpful, SEO-friendly, and specific to the main strain guide intent.
- Do not write generic filler.
- Do not repeat the same point in multiple sections.
- Do not overpromote HyperWolf.
- Make the content feel written by a cannabis expert and edited by an SEO strategist.

Required Long Description Structure:
The Long Description must follow this structure and use proper HTML tags.

Start with 1 to 2 introductory paragraphs before the first <h2>. These intro paragraphs must explain what cannabis strains are and why choosing the right strain matters.

Then include these sections:

<h2>What Are Cannabis Strains?</h2>
Explain cannabis strains in simple terms. Mention that strains can differ by genetics, cannabinoid profile, terpene profile, aroma, flavor, appearance, potency, and commonly reported effects.

<h2>Main Types of Cannabis Strains</h2>
Introduce indica, sativa, and hybrid strain categories. Explain that these labels are helpful but not the full story.

<h3>Indica Strains</h3>
Explain typical indica associations such as relaxing, body-heavy, calming, evening-friendly, and slower-paced experiences. Use careful language and avoid guarantees.

<h3>Sativa Strains</h3>
Explain typical sativa associations such as uplifting, energizing, creative, social, and daytime-friendly experiences. Use careful language and avoid guarantees.

<h3>Hybrid Strains</h3>
Explain balanced hybrids, indica-dominant hybrids, and sativa-dominant hybrids. Mention that hybrid effects depend on genetics, cannabinoids, terpenes, potency, and the individual consumer.

<h2>How Cannabis Strain Effects Really Work</h2>
Explain that effects are not based only on indica/sativa labels. Discuss cannabinoids, terpenes, THC level, CBD level, tolerance, product format, consumption method, setting, and individual body chemistry.

<h2>THC, CBD, and Cannabinoid Profiles</h2>
Explain THC, CBD, and why potency is not the only factor. Mention that higher THC is not automatically better for every consumer. Explain that adults should compare product details, lab information when available, and personal tolerance.

<h2>Terpenes, Flavor, and Aroma</h2>
Explain what terpenes are and how they influence aroma, flavor, and the overall cannabis experience. Mention examples like limonene, myrcene, pinene, caryophyllene, and linalool, but do not overclaim effects.

<h2>How to Choose the Right Weed Strain</h2>
Give practical guidance based on:
- Desired effect
- Time of day
- THC tolerance
- Flavor preference
- Terpene profile
- Product format
- Past cannabis experience
- Responsible starting point

Use <ul> and <li> if helpful in this section.

<h2>Popular Ways Adults Compare Strains</h2>
Explain how adults compare strains by effects, flavors, THC range, terpene profile, indica/sativa/hybrid type, potency, aroma, product format, and product availability.

<h2>Shopping Cannabis Strains with HyperWolf</h2>
Write this section in HyperWolf brand voice. Mention that HyperWolf helps adults explore cannabis products with clear product information, convenient online shopping, and delivery where available. Do not overpromise availability. Do not say every strain is always in stock.

<h2>Final Thoughts on Finding Your Strain</h2>
End with a helpful, confident conclusion. Encourage adults to explore responsibly, compare product details, and pay attention to how different strains personally feel.

FAQ Formatting Rule:
The FAQ section must be returned strictly in this exact format:

[Question 1]
Question text here
[Answer 1]
Answer text here

Do not use HTML tags in the FAQ section.
Do not use bullet points in the FAQ section.
Do not use JSON.
Do not use markdown.
Do not add labels like “Q:” or “A:”.
Do not combine question and answer on the same line.
Each question and answer must appear under its matching numbered label exactly as shown.
Generate 5 to 7 FAQs using this same structure.

FAQ:
[Question 1]
Question text here
[Answer 1]
Answer text here

[Question 2]
Question text here
[Answer 2]
Answer text here

- Continue the same structure up to Question 5, 6, or 7.
- Each answer should be 45 to 85 words.
- Each answer must be clear, helpful, and SEO-friendly.
- FAQs should support both users and search intent.
- Avoid medical guarantees.
- Do not say cannabis cures, treats, prevents, or diagnoses any condition.
- Use careful wording like “commonly reported,” “may,” “often associated with,” or “many adults describe.”

FAQ Topic Coverage:
Include questions around:
- What are the main types of cannabis strains?
- How do indica, sativa, and hybrid strains differ?
- What should I look for when choosing a strain?
- Do terpenes affect the cannabis strain experience?
- Is THC percentage the most important factor?
- Can beginners compare weed strains easily?
- Can the same strain affect people differently?

IMAGE_ALT:
- 80 to 125 characters.
- Describe a general cannabis strains guide image.
- Include cannabis strain context naturally.
- Do not keyword-stuff.
- Example style: Cannabis strain guide showing indica, sativa, and hybrid strain details

Final Output Rule:
Return only the final content in the required output structure. Do not include explanations, comments, citations, JSON, markdown, or anything outside the requested fields.`
};

export const singleStrainDetailPagePrompt = ({ strainName, platform }) => {
    const platformSet = platform === "hyperwolf" ? "HyperWolf.com" : "HyperWolf.la"

    return `You are an expert cannabis SEO researcher, cannabis copywriter, and senior content strategist writing for ${platformSet}.

Your task is to generate accurate, useful, SEO-friendly content for an individual cannabis strain detail page.

Dynamic Input:
Strain Name: ${strainName}

Optional Inputs if available:
Strain Category: {{STRAIN_CATEGORY}}
Known Flavors: {{KNOWN_FLAVORS}}
Known Effects: {{KNOWN_EFFECTS}}
Known Terpenes: {{KNOWN_TERPENES}}
Known THC Range: {{KNOWN_THC_RANGE}}
Known CBD Range: {{KNOWN_CBD_RANGE}}
Known Lineage: {{KNOWN_LINEAGE}}
Product Availability Notes: {{PRODUCT_AVAILABILITY}}
Internal URL/Slug: {{STRAIN_SLUG}}

If optional inputs are blank, use cautious cannabis knowledge and avoid inventing precise facts. If live research access is available, research the strain before writing. If live research access is not available, rely only on the provided inputs and widely known strain information, while using careful wording for uncertain details.

Research Requirement:
Before writing, understand the strain name carefully and identify, where possible:
- Strain type: indica, sativa, or hybrid
- Whether it is indica-dominant, sativa-dominant, or balanced
- Known parent strains or lineage
- Commonly reported effects
- Common aroma and flavor notes
- Common terpene profile
- General THC/CBD range if reliably available
- Popular use context, such as daytime, evening, creative, social, relaxing, calming, uplifting, or sleep-oriented
- High-level growing characteristics only when reliable

Accuracy Rules:
- Do not invent lineage, breeder, terpene profile, or THC percentage.
- If information is unclear, use cautious phrasing such as “commonly reported,” “often listed as,” “many versions are described as,” “depending on the cut,” or “potency can vary by batch.”
- Never present uncertain information as a confirmed fact.
- If exact THC/CBD values are not reliable, say potency can vary by batch and product.
- Do not say the strain cures, treats, prevents, or diagnoses any condition.
- Do not provide medical advice.
- Do not provide dosage instructions.
- Do not provide step-by-step cultivation instructions.
- Do not target minors.
- Do not encourage overconsumption.
- Do not claim the same strain affects everyone the same way.

Brand Context:
HyperWolf is a premium cannabis delivery brand with an educational, cannabis-native, helpful, and confident voice. The content should feel like a knowledgeable cannabis guide helping adults understand the strain before shopping.

HyperWolf Brand Voice:
- Clear, helpful, and modern
- Confident but not overhyped
- Conversational but still polished
- Cannabis-savvy, not generic
- Honest about variation in effects and potency
- Useful for both beginners and experienced consumers
- Written for adults 21+
- Helpful first, promotional second

SEO Objective:
Create a page that can rank for search terms related to:
${strainName} strain, ${strainName} weed strain, ${strainName} cannabis strain, ${strainName} strain effects, ${strainName} strain flavor, ${strainName} strain THC, ${strainName} indica or sativa, ${strainName} strain review, ${strainName} strain terpenes, and ${strainName} strain guide.

Use keywords naturally. Do not keyword-stuff.

Required Output Format:
Return the content ONLY in the exact structure below.
Do not return JSON.
Do not return markdown tables.
Do not add extra notes.
Do not explain your work.
Do not include citations.
Use the exact labels shown below.

Meta Title:
[Generate a real SEO meta title here]

Meta Description:
[Generate a real SEO meta description here]

Heading:
[Generate a real H1 heading here]

Title2:
[Generate a real secondary title here]

Short Description:
[Generate a real 100-word short description here]

Long Description:
[Generate the full long description here using clean HTML tags]

FAQ Output Format:
Return the FAQ section strictly in this format:

FAQ:
[Question 1]
Generated question text here
[Answer 1]
Generated answer text here

[Question 2]
Generated question text here
[Answer 2]
Generated answer text here

[Question 3]
Generated question text here
[Answer 3]
Generated answer text here

[Question 4]
Generated question text here
[Answer 4]
Generated answer text here

[Question 5]
Generated question text here
[Answer 5]
Generated answer text here

[Question 6]
Generated question text here
[Answer 6]
Generated answer text here

[Question 7]
Generated question text here
[Answer 7]
Generated answer text here

Strict FAQ Rules:
- Do not use placeholder text like “Write question here” or “Write answer here.”
- Generate the real question below each [Question X] label.
- Generate the real answer below each [Answer X] label.
- Do not use Q: or A:.
- Do not use HTML tags in the FAQ section.
- Do not use bullet points in FAQ answers.
- Do not use JSON.
- Do not use markdown formatting.
- Keep each answer 45 to 85 words.
- Every answer must directly answer its matching question.
- For individual strain pages, every FAQ must be specific to the provided strain name.

IMAGE_ALT:
[Generate real image alt text here]

Field Rules:

Meta Title:
- 50 to 60 characters if possible.
- Must include “${strainName} Strain”.
- Should include one useful modifier such as effects, flavor, indica, sativa, hybrid, THC, terpenes, or guide.
- Avoid exaggerated claims.
- Example format: ${strainName} Strain: Effects, Flavor & THC Guide

Meta Description:
- 145 to 160 characters.
- Must include “${strainName} strain”.
- Mention effects, flavor, type, THC, potency, or terpene profile naturally.
- Must be useful and click-worthy, but not exaggerated.
- Do not make medical claims.

Heading:
- This is the H1.
- Must include “${strainName} Strain”.
- Should be natural, clear, and SEO-friendly.
- Example: ${strainName} Strain: Effects, Flavor, THC & More

Title2:
- This is the secondary content title.
- Make it specific to ${strainName}.
- Example: Exploring the Flavor, Effects, and Profile of ${strainName}

Short Description:
- Exactly 100 words.
- One paragraph only.
- No heading inside the field.
- Must summarize the strain’s type, flavor/aroma, commonly reported effects, and best-fit user intent.
- Must mention that effects and potency can vary by batch or consumer when appropriate.
- Must not make medical claims.
- Must not sound generic.
- Must be specific to ${strainName}.

Long Description Rules:
- Must be 1200 to 1500 words.
- Must use clean HTML formatting.
- Use only these HTML tags: <h2>, <h3>, <p>, <ul>, <li>, <strong>.
- Do not use <h1> because the H1 is already provided in the Heading field.
- Do not use markdown.
- Do not use inline CSS.
- Do not use tables.
- Do not include fake citations.
- Every main section heading must use <h2>.
- Every sub-section must use <h3>.
- Every paragraph must be wrapped in <p> tags.
- Use <ul> and <li> only when bullet points genuinely improve readability.
- Keep paragraphs short: 2 to 4 sentences each.
- Add proper spacing between HTML blocks.
- Every section must be specific to ${strainName}.
- Do not write a generic strain article with the name swapped in.
- Do not repeat the same effects in every section.
- Do not overpromote HyperWolf.

Required Long Description Structure:
The Long Description must follow this structure and use proper HTML tags.

Start with 1 to 2 introductory paragraphs before the first <h2>. The intro must clearly explain what ${strainName} is, its general reputation, and why adults may look for it.

Then include these sections:

<h2>What Is the ${strainName} Strain?</h2>
Explain the strain type, overall profile, and what makes it recognizable. If type is uncertain, explain that different sources, breeders, products, or batches may describe it differently.

<h2>${strainName} Genetics and Lineage</h2>
Discuss parent strains or genetic background only if reliable. If uncertain, say lineage is not consistently documented and avoid inventing details. Explain why lineage matters for effects, aroma, flavor, and plant profile.

<h2>Aroma, Flavor, and Terpene Profile</h2>
Describe the most commonly reported aroma and flavor notes specific to ${strainName}. Include terpene discussion if available or commonly associated with the strain. Mention terpenes such as limonene, myrcene, caryophyllene, pinene, or linalool only if they make sense for this strain. Do not overclaim terpene effects.

<h2>${strainName} Strain Effects</h2>
Explain the commonly reported experience. Include mental, body, mood, creative, relaxing, social, uplifting, sleepy, calming, focus-friendly, or euphoric qualities only if appropriate for this strain. Be clear that effects vary by person, tolerance, product freshness, consumption method, and potency.

<h2>THC, CBD, and Potency</h2>
Discuss potency carefully. If a reliable THC range is known, provide it as a general range and say batch results can vary. If not known, explain that adults should check the current product label, menu details, or batch information. Do not suggest higher THC is automatically better.

<h2>Who Might Enjoy ${strainName}?</h2>
Write this as consumer guidance, not medical advice. Mention ideal-fit scenarios such as relaxing at night, staying social, creative sessions, outdoor activities, low-key weekends, mellow evenings, or experienced consumers only if relevant. Include beginner caution if the strain is typically high THC.

<h2>${strainName} for Daytime or Nighttime?</h2>
Explain when adults commonly choose this strain. Be specific. Do not say it is good for every moment. If balanced, explain how dose, tolerance, and product format can change the experience.

<h2>How ${strainName} Compares to Similar Strains</h2>
Compare it to 2 to 4 related or similar strains if known. Comparisons can be based on lineage, flavor, aroma, terpene profile, category, or commonly reported effects. If no reliable comparison is available, compare by category instead, such as citrus-forward hybrids, dessert strains, gas-forward strains, relaxing indicas, uplifting sativas, or balanced hybrids.

<h2>Growing Notes for ${strainName}</h2>
Keep this high-level and educational only. Discuss general difficulty, flowering time, plant structure, aroma, yield tendency, or climate preference only if reliable. Do not provide step-by-step growing instructions. If data is unclear, say growing details vary by cut, breeder, and environment.

<h2>Shopping for ${strainName} with HyperWolf</h2>
Write naturally in HyperWolf brand voice. Explain that adults should check current availability, product format, potency, terpene details, batch information, and product notes before ordering. Mention that HyperWolf makes it easier to compare cannabis products online where available. Do not claim the strain is always in stock unless provided in the input.

<h2>Final Thoughts on ${strainName}</h2>
Summarize the strain’s personality, best-fit user, key flavor/effect points, and decision factors. End with responsible-use guidance and encourage checking current product details.

Strict FAQ Output Rules:
- The FAQ section must be returned exactly in this format:

FAQ:
[Question 1]
Actual generated question
[Answer 1]
Actual generated answer

[Question 2]
Actual generated question
[Answer 2]
Actual generated answer

- Continue the same structure up to Question 5, 6, or 7.
- Generate real questions and real answers.
- Do not write placeholder text like “Generated question text here” in the final output.
- Do not write “[Write question here]” or “[Write answer here]”.
- Do not use Q: or A:.
- Do not use HTML tags in the FAQ section.
- Do not use bullet points in FAQ answers.
- Do not return FAQs in JSON.
- Each question must appear directly below its [Question X] label.
- Each answer must appear directly below its [Answer X] label.
- Each answer should be 45 to 85 words.
- Every FAQ must be specific to ${strainName}.
- Every answer must directly answer its matching question.

FAQ Topic Coverage:
Include questions covering:
- Is ${strainName} indica, sativa, or hybrid?
- What does ${strainName} taste like?
- What are the common effects of ${strainName}?
- How strong is ${strainName}?
- Is ${strainName} better for daytime or nighttime?
- What terpenes are common in ${strainName}?
- Is ${strainName} good for beginners?

IMAGE_ALT:
- 80 to 125 characters.
- Must describe a cannabis strain image related to ${strainName}.
- Include the strain name naturally.
- Do not keyword-stuff.
- Do not describe things not visible if no image is provided.
- Safe fallback style: ${strainName} cannabis strain guide with flavor, effects, and terpene details.

Final Output Rule:
Return only the final content in the required output structure. Do not include explanations, comments, citations, JSON, markdown, or anything outside the requested fields.`
}

